import React from "react";
import { Select, Button, Icon, Tooltip } from "antd";
import classNames from "classnames";
import WeaTools from "../../wea-tools";
import isEmpty from "lodash/isEmpty";
import debounce from "lodash/debounce";
import trim from "lodash/trim";
import isString from "lodash/isString";
import isFunction from "lodash/isFunction";
import random from "lodash/random";
import WeaHelpfulTip from "../../wea-helpful-tip";
import WeaLocaleProvider from "../../wea-locale-provider";
import WindowFunc from "../../wea-tools/window";

const { formatMultiLang } = WeaLocaleProvider;
const Option = Select.Option;

class main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      value: [],
      loading: false,
      focus: false,
      dropdownWidth: 200,
      activeKey: ""
    };
  }
  // 根据ids 更新组件
  updateByIds(ids, names) {
    const { type } = this.props;
    if (ids && names) {
      this.setState({ data: [{ id: ids, name: names }], value: [ids] });
    } else {
      this.setState({ data: [], value: [] });
    }
  }
  componentDidMount() {
    const { dropdownWidth } = this.state;
    this.updateByIds(this.props.ids, this.props.names);
    const w = $(this.refs.searchWrapper).outerWidth();
    if (dropdownWidth < w) {
      this.setState({ dropdownWidth: w });
    }
  }
  componentWillReceiveProps(nextProps, nextState) {
    if (
      (this.props.ids !== nextProps.ids && nextProps.ids) ||
      (this.props.names !== nextProps.names && nextProps.names)
    ) {
      this.updateByIds(nextProps.ids, nextProps.names);
    }
    if (
      this.props.defaultFocus !== nextProps.defaultFocus &&
      nextProps.defaultFocus
    ) {
      this.setState({ focus: true });
    }
    this.props.isClearData !== nextProps.isClearData && this.forceClear();
  }
  componentDidUpdate() {
    const dom = this.refs.searchWrapper;
    if (this.state.focus) {
      $(dom)
        .find(".ant-select-search--inline")
        .css("minWidth", "10px");
      $(dom)
        .find("input")
        .focus();
    } else {
      $(dom)
        .find(".ant-select-search--inline")
        .css("minWidth", "0px");
    }
  }
  focus() {
    this.refs.select.refs.rcSelect.onPlaceholderClick &&
      this.refs.select.refs.rcSelect.onPlaceholderClick();
  }
  // shouldComponentUpdate(nextProps,nextState) {
  //   return this.props.style !== nextProps.style
  //     || this.props.isClearData !== nextProps.isClearData
  //     || this.props.modalVisable !== nextProps.modalVisable
  //     || this.props.ids !== nextProps.ids
  //     || this.props.names !== nextProps.names
  //     || this.props.inputId !== nextProps.inputId
  //     || this.props.type !== nextProps.type
  //     || this.props.viewAttr !== nextProps.viewAttr
  //     || this.props.defaultFocus !== nextProps.defaultFocus
  //     || this.state.loading !== nextState.loading
  //     || this.state.value !== nextState.value
  //     || this.state.data !== nextState.data
  //     || this.state.loading !== nextState.loading;
  // }
  forceClear() {
    this.setState({ data: [], value: [] });
  }
  getData(name = "") {
    let { type, oldUrl, completeURL } = this.props;
    const { value } = this.state;
    type = type || 1;
    name = trim(name);
    let data = [];
    this.setState({ searchCache: name });
    if (value.length > 0) {
      let item = this.getItemById(value[0]);
      data = [item];
    }
    let url = completeURL || `/api/public/browser/complete/${type}?`;
    if (oldUrl) {
      url = `/api/ec/api/data/search?type=${type}&`;
    }
    if (name) {
      WeaTools.callApi(`${url}q=${encodeURIComponent(name)}`, "GET").then(
        res => {
          if (this.state.searchCache !== name) return;
          let resD =
            isString(res.datas) && res.datas.length > 0
              ? JSON.parse(res.datas)
              : res.datas;
          if (oldUrl) resD = res;
          resD = resD || [];
          data = data.concat(resD);
          this.setState({
            data: data,
            loading: false,
            activeKey: this.getActiveKey(data)
          });
        }
      );
    } else {
      this.setState({
        data: data,
        loading: false,
        activeKey: this.getActiveKey(data)
      });
    }
  }
  handleBlur() {
    this.getData();
    this.setState({ activeKey: "" });
    this.props.onBlur && this.props.onBlur();
  }
  handleFocus() {
    this.setState({ focus: true });
    this.props.onFocus && this.props.onFocus();
  }
  getItemById(id) {
    const { data } = this.state;
    let item = {};
    if (!isEmpty(data)) {
      for (let i = 0; i < data.length; i++) {
        if (id === data[i].id) {
          return data[i];
        }
      }
    }
    return item;
  }
  updateValue(value) {
    if (this.props.onChange) {
      let item = this.getItemById(value);
      this.props.onChange(value || "", item.name, [item]);
    }
  }
  // 处理单选
  handleSelect(value) {
    let item = this.getItemById(value);
    if (!isEmpty(item)) {
      this.setState({ value: [value], data: [item], activeKey: "" });
      this.updateValue(value);
    }
  }
  // 是否是人力浏览按钮
  isCrm() {
    const type = this.props.type || 1;
    return type === 1 || type === 17 || type === "1" || type === "17";
  }
  //只读
  isReadOnly() {
    const { viewAttr } = this.props;
    return viewAttr === 1 || viewAttr === "1";
  }
  //处理点击
  selectedClickHandler(e) {
    let item = this.state.data[0];
    if (this.isCrm()) {
      window.openhrm(item.id);
      window.pointerXY(e.nativeEvent);
    } else {
      const { linkUrl, inputId, onLinkClick } = this.props;
      if (isFunction(onLinkClick)) {
        onLinkClick(e, item);
      } else if (linkUrl) {
        let url = `${linkUrl}${item[inputId] || item.id}`;
        window.open(url);
      }
    }
  }
  // 处理单选
  handleDeselect(value) {
    this.setState({ value: [], data: [], activeKey: "" });
    this.updateValue();
  }
  handleSearch(value) {
    this.setState({ loading: true });
    this.getData(value);
    this.props.onSearch && this.props.onSearch(value);
  }
  handleClick(e) {
    e && e.preventDefault();
    if (this.props.onBeforeFocusCheck) {
      let cb = this.handleClickInner.bind(this);
      this.props.onBeforeFocusCheck(cb);
    } else {
      this.handleClickInner(e);
    }
  }
  handleClickInner(e) {
    if (this.props.clickCallback) {
      this.props.clickCallback(this.state.data);
    }
  }
  getActiveKey(data) {
    let v = "";
    const { value } = this.state;
    if (data && data.length > 0) {
      v = data[0].id;
      if (!isEmpty(value)) {
        let target = data.filter(d => d.id !== value[0]);
        if (!isEmpty(target)) v = target[0].id;
      }
    }
    return v;
  }
  addOnClick() {
    this.props.addOnClick && this.props.addOnClick();
  }
  readOnlyCallback(data, e) {
    this.props.readOnlyCallback && this.props.readOnlyCallback(data);
  }
  render() {
    const { value, data: _data, dropdownWidth, activeKey } = this.state;
    const {
      whiteBackground,
      customIconTip,
      mr0,
      customIcon,
      underline,
      showTitle = false,
      fieldName,
      hasBorder,
      viewAttr,
      style = {},
      tempTitle,
      cls,
      resize,
      isCity,
      linkUrl,
      isDetail,
      hasAddBtn,
      modalVisable,
      hasScroll = true,
      layout,
      hideOps,
      hideSelect,
      helpfulTip,
      helpfulTipProps,
      className,
      noTooltip = false
    } = this.props;
    let clss = cls || "";
    const cStyle = { ...style };
    cStyle.textDecoration = "none";
    const { props } = this;
    const clsname = classNames({
      required: viewAttr == "3" && isEmpty(value),
      mr15: /^field/.test(fieldName) || (viewAttr == "3" && isEmpty(value)),
      mr0: mr0,
      resize: resize,
      "wea-associative-click":
        this.isCrm() || !isEmpty(linkUrl) || props.linked,
      custom: hasAddBtn || customIcon,
      "ext-btn": hasAddBtn || customIcon,
      border: hasBorder,
      white: whiteBackground,
      underline: underline,
      hideops: hideOps,
      [`${className}`]: className
    });
    const data = _data.map(d => ({
      ...d,
      name: formatMultiLang(d.name)
    }));
    if (this.isReadOnly()) {
      return (
        <span
          id={`${this.props.fieldName}span`}
          className={`wea-associative-search wea-field-readonly ${clsname} ${clss}`}
          style={cStyle}
          ref="searchWrapper"
        >
          {!isEmpty(value) &&
            !isEmpty(data) &&
            isString(data[0].name) &&
            !this.props.readOnlyCallback && (
              <a
                className="child-item wdb"
                onClick={e => this.selectedClickHandler(e)}
                title={data[0].name}
                dangerouslySetInnerHTML={{ __html: data[0].name }}
              />
            )}
          {!isEmpty(value) &&
            !isEmpty(data) &&
            isString(data[0].name) &&
            this.props.readOnlyCallback && (
              <a
                className="child-item wdb"
                title={data[0].name}
                onClick={this.readOnlyCallback.bind(this, data)}
                dangerouslySetInnerHTML={{ __html: data[0].name }}
              />
            )}
          {!isEmpty(value) &&
            !isEmpty(data) &&
            !isString(data[0].name) &&
            !this.props.readOnlyCallback && (
              <a
                className="child-item wdb"
                onClick={e => this.selectedClickHandler(e)}
              >
                {data[0].name}
              </a>
            )}
          {!isEmpty(value) &&
            !isEmpty(data) &&
            !isString(data[0].name) &&
            this.props.readOnlyCallback && (
              <a
                className="child-item wdb"
                onClick={this.readOnlyCallback.bind(this, data)}
              >
                {data[0].name}
              </a>
            )}
          {hasAddBtn && (
            <div className="ant-input-group-wrap custom extbtn">
              <Icon
                className="add-icon"
                type="plus"
                onClick={this.addOnClick.bind(this)}
              />
            </div>
          )}
          {customIcon && (
            <div className="ant-input-group-wrap extbtn custom">
              {customIconTip ? (
                <Tooltip placement="bottom" title={customIconTip}>
                  <i
                    className={`${customIcon} add-icon`}
                    onClick={this.addOnClick.bind(this)}
                  />
                </Tooltip>
              ) : (
                <i
                  className={`${customIcon} add-icon`}
                  onClick={this.addOnClick.bind(this)}
                />
              )}
            </div>
          )}
          {helpfulTip && (
            <WeaHelpfulTip
              style={{ position: "absolute", right: -31, top: 4 }}
              title={helpfulTip}
              {...helpfulTipProps}
            />
          )}
        </span>
      );
    }
    let optionsError = false;
    let options = data
      .map(d => {
        if (!d.id) {
          console && console.error(`浏览按钮脏数据 ${d}`);
          optionsError = true;
        }
        const tooltip = noTooltip ? "" : d.title || d.name;
        return (
          <Option value={d.id} key={random(1000000000)} tooltip={tooltip}>
            {d.name}
          </Option>
        );
      })
      .filter(v => !!v);
    optionsError && (options = []);

    let select = (
      <Select
        selectedClickCB={this.selectedClickHandler.bind(this)}
        {...this.props}
        onChange={() => {}} // 覆盖onChange
        ref="select"
        fieldName={fieldName}
        hasScroll={hasScroll}
        onInputBlur={() => {
          this.setState({ focus: false });
        }}
        title={tempTitle}
        hideSelected={true}
        transitionName=""
        animation=""
        value={value}
        multiple={true}
        placeholder={this.props.placeholder}
        notFoundContent=""
        activeKey={activeKey}
        defaultActiveFirstOption={true}
        showArrow={false}
        filterOption={false}
        onSelect={this.handleSelect.bind(this)}
        onBlur={this.handleBlur.bind(this)}
        onFocus={this.handleFocus.bind(this)}
        onDeselect={this.handleDeselect.bind(this)}
        onSearch={!hideSelect && debounce(this.handleSearch, 400).bind(this)}
        selectedClose={true}
        dropdownStyle={{ minWidth: dropdownWidth }}
        dropdownMenuStyle={{ maxHeight: 160 }}
        getPopupContainer={() =>
          (this.props.getPopupContainer && this.props.getPopupContainer()) ||
          layout ||
          WindowFunc.getTop().document.body
        }
      >
        {options}
      </Select>
    );
    // if (hideSelect) {
    //   select = null;
    // }
    let singleTitle = "";
    if (
      showTitle &&
      !isEmpty(value) &&
      !isEmpty(data) &&
      isString(data[0].name)
    ) {
      function escape2Html(str) {
        var arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
        return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function(all, t) {
          return arrEntities[t];
        });
      }
      singleTitle = escape2Html(data[0].name);
    }

    return (
      <div
        title={singleTitle}
        className={`wea-associative-search wea-associative-single ${clss} ${clsname}`}
        style={cStyle}
        ref="searchWrapper"
      >
        {select}
        <Icon
          type="loading"
          style={{ display: this.state.loading ? "block" : "none" }}
        />
        {!hideOps && (
          <div className="ant-input-group-wrap">
            {!isCity ? (
              <Button
                type="ghost"
                icon="search"
                onClick={this.handleClick.bind(this)}
              />
            ) : (
              <Button
                type="ghost"
                style={{ paddingTop: "4px" }}
                size="small"
                onClick={this.handleClick.bind(this)}
              >
                <span>
                  {modalVisable ? (
                    <i className="icon-coms-up" />
                  ) : (
                    <i className="icon-coms-down" />
                  )}
                </span>
              </Button>
            )}
          </div>
        )}
        {hasAddBtn && (
          <div className="ant-input-group-wrap extbtn">
            <Icon
              className="add-icon"
              type="plus"
              onClick={this.addOnClick.bind(this)}
            />
          </div>
        )}
        {customIcon && (
          <div className="ant-input-group-wrap extbtn custom">
            {customIconTip ? (
              <Tooltip placement="bottom" title={customIconTip}>
                <i
                  className={`${customIcon} add-icon`}
                  onClick={this.addOnClick.bind(this)}
                />
              </Tooltip>
            ) : (
              <i
                className={`${customIcon} add-icon`}
                onClick={this.addOnClick.bind(this)}
              />
            )}
          </div>
        )}
        {helpfulTip && (
          <WeaHelpfulTip
            style={{ position: "absolute", right: -31, top: 4 }}
            title={helpfulTip}
            {...helpfulTipProps}
          />
        )}
      </div>
    );
  }
}
export default main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-associative-search/index.js